import { createSlice } from "@reduxjs/toolkit";

export const lockerUserTypeSlice = createSlice({
  name: "lockerUserType",
  initialState: {
    userTypeData: [],
    addedUserTypeData: [],
  },
  reducers: {
    getUserTypeData: (state, actions) => {
      state.userTypeData = actions.payload;
    },
    handleOnEditUserTypeReducer: (state, actions) => {
      let tempUserTypeData = [...state.userTypeData];
      const { rowId, newValue, field } = actions.payload;
      tempUserTypeData[rowId][field] = newValue;
      state.userTypeData = tempUserTypeData;
    },
    handleOnAddUserTypeReducer: (state, actions) => {
      state.addedUserTypeData.push(actions.payload);
    },
    handleOnChangeAddedUserTypeReducer: (state, actions) => {
      let tempAddedUserType = [...state.addedUserTypeData];
      const { name, id, value } = actions.payload;
      tempAddedUserType[id][name] = value;
      state.addedUserTypeData = tempAddedUserType;
    },
    handleOnDeleteUserTypeOnFormReducer: (state, actions) => {
      let tempUserType = [...state.addedUserTypeData];
      tempUserType.splice(actions.payload, 1);
      state.addedUserTypeData = tempUserType;
    },
    handleSaveChangesReducer: (state, actions) => {
      console.log(JSON.parse(JSON.stringify(state.userTypeData)));
    },
    handleClearAllForms: (state) => {
      state.addedUserTypeData = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getUserTypeData,
  handleOnEditUserTypeReducer,
  handleOnAddUserTypeReducer,
  handleOnDeleteUserTypeOnFormReducer,
  handleOnChangeAddedUserTypeReducer,
  handleSaveChangesReducer,
  handleClearAllForms,
} = lockerUserTypeSlice.actions;

export default lockerUserTypeSlice.reducer;
